import { Resource } from "../resource/resource.model";

/**
 * 4Bridge Webhook Endpoint Model
 * Represents a webhook endpoint for receiving/sending notifications
 */
export class BridgeWebhookEndpoint extends Resource {
    name: string;
    url: string;
    secret?: string;
    events: string[];
    isEnabled: boolean;
    headers?: Record<string, string>;
    retryCount?: number;
    retryDelaySeconds?: number;
    lastTriggeredAt?: Date;
    businessUnit?: string;
    createdAt?: Date;
    updatedAt?: Date;
}

/**
 * Request DTO for creating a webhook endpoint
 */
export interface CreateWebhookEndpointRequest {
    name: string;
    url: string;
    secret?: string;
    events: string[];
    isEnabled?: boolean;
    headers?: Record<string, string>;
    retryCount?: number;
    retryDelaySeconds?: number;
    businessUnit?: string;
}

/**
 * Request DTO for updating a webhook endpoint
 */
export interface UpdateWebhookEndpointRequest {
    name?: string;
    url?: string;
    secret?: string;
    events?: string[];
    isEnabled?: boolean;
    headers?: Record<string, string>;
    retryCount?: number;
    retryDelaySeconds?: number;
    businessUnit?: string;
}

/**
 * Webhook event types enum
 */
export enum WebhookEvent {
    SYNC_STARTED = 'sync.started',
    SYNC_COMPLETED = 'sync.completed',
    SYNC_FAILED = 'sync.failed',
    RECORD_CREATED = 'record.created',
    RECORD_UPDATED = 'record.updated',
    RECORD_DELETED = 'record.deleted',
    CONNECTION_STATUS_CHANGED = 'connection.status_changed',
    INTEGRATION_ENABLED = 'integration.enabled',
    INTEGRATION_DISABLED = 'integration.disabled'
}

/**
 * Webhook delivery log
 */
export interface WebhookDeliveryLog {
    id: string;
    webhookEndpointId: string;
    event: string;
    payload: any;
    responseStatus?: number;
    responseBody?: string;
    deliveredAt?: Date;
    attemptNumber: number;
    isSuccess: boolean;
    errorMessage?: string;
}
